import { useSelector } from 'react-redux';

import { RootState } from 'reducers/rootReducer';

export default function usePreferredAllergens() {
	return useSelector((state: RootState) => state.preferredAllergens);
}
